/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpSharedDetailItemInvoice_user$ref = any;
export type PdpSharedDetailItemInvoice_user = {
    readonly profile: {
        readonly email: string | null;
    } | null;
    readonly authMetadata: {
        readonly emailOnly: boolean | null;
    } | null;
    readonly " $refType": PdpSharedDetailItemInvoice_user$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedDetailItemInvoice_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "profile",
      "storageKey": null,
      "args": null,
      "concreteType": "Profile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "email",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "authMetadata",
      "storageKey": null,
      "args": null,
      "concreteType": "UserExistsMetadataType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "emailOnly",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '52c70a9223a8dedffbc22d2b426e6dcd';
export default node;
